import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "../../i18n/locale";
import { useEffect, useState } from "react";
import { CircularProgress, Box } from "@mui/material";

const i18n = i18next.createInstance().use(initReactI18next);
interface IProps {
  children: React.ReactNode;
}

export const I18TransalteProvider = ({ children }: IProps) => {
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    i18n
      .use(initReactI18next)
      .init({
        resources,
        lng: "en",
        interpolation: {
          escapeValue: false,
        },
      })
      .then(() => {
        setIsInitialized(true);
      });
  }, []);
  return isInitialized ? (
    <>{children}</>
  ) : (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress />
    </Box>
  );
};
